import { useCallback, useState } from 'react'

import ContentHeader from 'components/ui/account/content/__header'
import SocialsBlocks from 'components/ui/account/socials'
import GoogleAuthPopup from 'components/ui/account/google-auth-popup'
import GoogleUnsetPopup from 'components/ui/account/google-unset-popup'
import AccountInfo from 'components/ui/account/account-info'
import ContentSubtitle from 'components/ui/account/content/__subtitle'

import { WhiteList } from 'pages/account/settings/components/white-list'

import { useHeader } from '../../../utils/use-header'

import { useAppDispatch } from '../../../store/hooks'

import { fetchUser } from '../../../store/reducers/users'

import styles from './styles.module.scss'
import LoginHistory from './components/white-list/components/login-history'
import { useTranslation } from 'utils/use-translation'

const Settings = () => {
  const { t } = useTranslation()

  const head = useHeader(t('settings'))
  const [popupOpened, setPopupOpened] = useState(null)
  const dispatch = useAppDispatch()

  const handleClosePopup2fa = useCallback(() => {
    setPopupOpened(null)
    dispatch(fetchUser())
  }, [])

  return (
    <div className={styles.settings}>
      {head}
      <ContentHeader className={styles.settings__header} title={t('settings')} />
      <ContentSubtitle className={styles.settings__subtitle}>
        {t('configure_your_account')}
      </ContentSubtitle>
      <AccountInfo onClickEnableBtn={() => setPopupOpened('auth')} onClickUnsetBtn={() => setPopupOpened('unset')} />
      <LoginHistory />
      <WhiteList openPopup={() => setPopupOpened('auth')} />
      <SocialsBlocks />

      {popupOpened === 'auth' && <GoogleAuthPopup onClose={handleClosePopup2fa} />}
      {popupOpened === 'unset' && <GoogleUnsetPopup onClose={handleClosePopup2fa} />}
    </div>
  )
}

export default Settings
